// extracted by mini-css-extract-plugin
export default {"content":"PaymentMethodsPage_content__lIwwv","desktopTopbar":"PaymentMethodsPage_desktopTopbar__2uZ2q","mobileTopbar":"PaymentMethodsPage_mobileTopbar__ClPl1"};